let id = Math.ceil(Math.random() * 10)

export const uid = () => {
  return ++id
}
